module.exports = __webpack_public_path__ + "static/Aionrise-0bdd202fd8deb2797a773178d5fd5262.png";